import React from "react";
import { useTranslation } from "react-i18next";
import { Linking, Text, View } from "react-native";

const CREDITS = [
  {
    name: "Noto Emoji Animation",
    by: "Google",
    license: "CC BY 4.0",
    use: "LABEL_CREDITS_REACTIONS",
    url: "https://googlefonts.github.io/noto-emoji-animation/",
    licenseUrl: "https://creativecommons.org/licenses/by/4.0/",
  },
  {
    name: "Fluent Emoji",
    by: "Microsoft",
    license: "MIT",
    use: "LABEL_CREDITS_STICKERS",
    url: "https://github.com/microsoft/fluentui-emoji",
    licenseUrl: "https://github.com/microsoft/fluentui-emoji/blob/main/LICENSE",
  },
  {
    name: "Open Peeps",
    by: "Pablo Stanley",
    license: "CC0 1.0",
    use: "LABEL_CREDITS_STICKERS",
    url: "https://www.openpeeps.com",
    licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
  },
] as const;

/** About: attribution required by the bundled emoji/sticker artwork. */
const CreditsSection = () => {
  const { t } = useTranslation();
  return (
    <View testID="credits-section" className="flex-col gap-3">
      <Text className="text-base font-semibold text-onyx">{t("LABEL_ABOUT_CREDITS")}</Text>
      {CREDITS.map((c) => (
        <View key={c.name} className="flex-col gap-0.5">
          <Text className="text-sm text-onyx">
            {t(c.use)}:{" "}
            <Text className="text-primary underline" onPress={() => Linking.openURL(c.url)}>
              {c.name}
            </Text>{" "}
            © {c.by},{" "}
            <Text className="text-primary underline" onPress={() => Linking.openURL(c.licenseUrl)}>
              {c.license}
            </Text>
          </Text>
        </View>
      ))}
      <Text className="text-xs text-ash-2">{t("LABEL_CREDITS_MODIFIED")}</Text>
    </View>
  );
};

export default CreditsSection;
